(function () {
  function initWellnessQuiz(root) {
    const quiz = root.querySelector('[data-wellness-quiz]');
    if (!quiz) return;

    const questions = [...quiz.querySelectorAll('[data-question]')];
    const submit = quiz.querySelector('[data-quiz-submit]');
    const scoreValue = root.querySelector('[data-score-value]');
    const scoreMessage = root.querySelector('[data-score-message]');
    const scoreProgress = root.querySelector('[data-score-progress]');
    const answers = new Map();

    questions.forEach((question, index) => {
      question.querySelectorAll('[data-answer]').forEach((button) => {
        button.addEventListener('click', () => {
          question.querySelectorAll('[data-answer]').forEach((item) => item.classList.remove('is-selected'));
          button.classList.add('is-selected');
          answers.set(index, button.dataset.answer);
          submit.disabled = answers.size !== questions.length;
        });
      });
    });

    submit?.addEventListener('click', () => {
      let score = 50;
      answers.forEach((value) => {
        score += value === 'yes' ? 12 : 8;
      });
      score = Math.min(score, 100);

      const scoreNumber = root.querySelector('[data-score-number]');
      if (scoreNumber) scoreNumber.textContent = String(score);
      if (scoreMessage) {
        scoreMessage.textContent =
          score >= 80 ? 'Excellent daily wellness habits.' : score >= 60 ? "You're on the right track." : 'Small daily improvements can make a big difference.';
      }
      if (scoreProgress) {
        const circumference = 327;
        scoreProgress.style.strokeDashoffset = `${circumference - (circumference * score) / 100}`;
      }
    });
  }

  function initCarousel(root, trackSelector, prevSelector, nextSelector, dotSelector) {
    const track = root.querySelector(trackSelector);
    if (!track) return;

    const prev = root.querySelector(prevSelector);
    const next = root.querySelector(nextSelector);
    const dots = dotSelector ? [...root.querySelectorAll(dotSelector)] : [];
    const slides = [...track.children];
    const scrollAmount = () => Math.max(track.clientWidth * 0.85, 260);

    const setActiveDot = (index) => {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.carouselDot);
        const slide = slides[index];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        setActiveDot(index);
      });
    });

    if (dots.length && slides.length) {
      track.addEventListener('scroll', () => {
        const center = track.scrollLeft + track.clientWidth / 2;
        let activeIndex = 0;
        let closestDistance = Infinity;
        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft - track.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(center - slideCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });
        setActiveDot(activeIndex);
      }, { passive: true });
    }
  }

  function initTestimonialsCarousel(section) {
    const track = section.querySelector('[data-testimonials-track]');
    if (!track) return;

    const originals = [...track.children].filter((slide) => !slide.classList.contains('is-clone'));
    const count = originals.length;
    if (count < 2) return;

    const dots = [...section.querySelectorAll('[data-carousel-dot]')];
    const gap = () => parseFloat(getComputedStyle(track).gap) || 0;

    const cloneSlide = (slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add('is-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      return clone;
    };

    track.insertBefore(cloneSlide(originals[count - 1]), originals[0]);
    track.appendChild(cloneSlide(originals[0]));

    const slides = [...track.children];
    let isJumping = false;
    let scrollTimer;

    const centerOffset = (slide) => {
      return slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2;
    };

    const scrollToIndex = (index, behavior = 'auto') => {
      const slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: Math.max(0, centerOffset(slide)), behavior });
    };

    const getClosestIndex = () => {
      const center = track.scrollLeft + track.clientWidth / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(center - slideCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    };

    const getRealIndex = (slideIndex) => {
      if (slideIndex === 0) return count - 1;
      if (slideIndex === count + 1) return 0;
      return slideIndex - 1;
    };

    const setActiveDot = (realIndex) => {
      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === realIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const handleLoopJump = () => {
      if (isJumping) return;

      const closestIndex = getClosestIndex();
      setActiveDot(getRealIndex(closestIndex));

      if (closestIndex === 0) {
        isJumping = true;
        scrollToIndex(count, 'auto');
        window.requestAnimationFrame(() => {
          isJumping = false;
        });
      } else if (closestIndex === count + 1) {
        isJumping = true;
        scrollToIndex(1, 'auto');
        window.requestAnimationFrame(() => {
          isJumping = false;
        });
      }
    };

    const queueLoopCheck = () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(handleLoopJump, 120);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.carouselDot);
        scrollToIndex(index + 1, 'smooth');
        setActiveDot(index);
      });
    });

    track.addEventListener(
      'scroll',
      () => {
        if (isJumping) return;
        setActiveDot(getRealIndex(getClosestIndex()));
        queueLoopCheck();
      },
      { passive: true }
    );

    track.addEventListener('scrollend', handleLoopJump, { passive: true });

    const startRealIndex = count > 2 ? 1 : 0;

    const initPosition = () => {
      scrollToIndex(startRealIndex + 1, 'auto');
      setActiveDot(startRealIndex);
    };

    initPosition();
    window.addEventListener('resize', initPosition, { passive: true });
  }

  document.querySelectorAll('.biophoriaa-wellness-calculator').forEach(initWellnessQuiz);
  document.querySelectorAll('.biophoriaa-testimonials').forEach(initTestimonialsCarousel);
  document.querySelectorAll('.biophoriaa-results-carousel').forEach((section) => {
    initCarousel(section, '[data-results-track]', '[data-carousel-prev]', '[data-carousel-next]');
  });
})();
